import { tw } from 'utils/classnames'
import { formatNumberToNumericalAbreviation } from 'utils/number'

interface StatProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  value: React.ReactNode
  className?: string
}

export function Stat({ icon, value, className, ...rest }: StatProps) {
  return (
    <div
      className={tw(
        'text-cf-dreamy-cloud-900 text-12 flex flex-col items-center justify-between',
        className,
      )}
      {...rest}
    >
      {icon}
      <div className="flex place-content-center">
        {typeof value === 'number' ? formatNumberToNumericalAbreviation(value) : value}
      </div>
    </div>
  )
}
